/** Legacy workflows put their step number in the name; order is separate UI metadata. */
export function actionDisplayName(name: string): string {
  return name.replace(/^\d{1,3}\s*[·.\-]\s+/, '').trim() || 'Untitled action'
}
